import React from "react";
import { Box, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faXTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

const Socials: React.FC = () => {
    const socials = [
        { name: "Facebook", icon: faFacebook, color: "#1877F2", link: "https://www.facebook.com/democratie.blr/" },
        { name: "Instagram", icon: faInstagram, color: "#E4405F", link: "https://www.instagram.com/vivre_la_democratie_a_blr/" },
        { name: "X (Twitter)", icon: faXTwitter, color: "#000000", link: "https://x.com/JeanPhi56448637" },
        { name: "YouTube", icon: faYoutube, color: "#FF0000", link: "https://www.youtube.com/channel/UCzY-QlEXExtESHRTxgNII-w" },
    ];

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 4, // Espacement entre les icônes
                py: 2
            }}
        >
            {socials.map((social) => (
                <Tooltip key={social.name} title={social.name} arrow>
                    <Box
                        component="a"
                        href={social.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            color: "text.secondary",
                            fontSize: "1.75rem",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "&:hover": {
                                color: social.color,
                                transform: "translateY(-3px) scale(1.1)",
                                filter: `drop-shadow(0 4px 6px ${social.color}40)`
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={social.icon} />
                    </Box>
                </Tooltip>
            ))}
        </Box>
    );
};

export default Socials;